import * as angular from 'angular';
import * as _ from 'underscore';
import { NgTableParams } from 'ng-table';
import { NotificationService } from './notification.service';

export class NgTableService {
    static $inject = ['notificationService'];

    constructor(private notificationService: NotificationService) { }

    getQuery(params: NgTableParams<void>) {
        var sort = _.pairs(params.sorting());
        var sortColumn = null, sortOrder = null;
        if (sort.length > 0) {
            sortColumn = sort[0][0];
            sortOrder = sort[0][1];
        }
        var query = {
            limit: params.count(),
            offset: (params.page() - 1) * params.count(),
            sortOrder: sortOrder,
            sortColumn: sortColumn,
        };

        var filter = params.filter();
        for (var filterItem in filter) {
            if (filter.hasOwnProperty(filterItem)) {
                query[filterItem] = filter[filterItem];
            }
        }
        if (query.sortColumn === 'undefined') {
            query.sortColumn = null;
        }
        return query;
    }
}

angular.module('app.common').service('ngTableService', NgTableService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/ng-table.service.ts